$(function () {
    let $modals = $('.modal');
    let $modal = $('#modal--requestUsername');
    let $content = $modal.find('.modal-body');
    let $form = $modal.find('form');
    let $original = $form;

    // let $email = $form.find('.email');

    let $success = $content.find('.alert-success');
    let $alert = $content.find('.alert-error');
    let $recaptcha = $content.find('.g-recaptcha');
    let id;

    $('.show-request-username').click(function (event) {
        event.preventDefault();
        $modals.modal('hide');
        $modal.modal('show');
        $success.addClass('d-none');
        $original.removeClass('d-none');

        if ($recaptcha.length && typeof grecaptcha !== 'undefined') {
            if (typeof id !== 'undefined') {
                grecaptcha.reset(id);
            } else {
                id = grecaptcha.render($recaptcha[0], $recaptcha.data());
            }
        } else if ($content.find('.LBD_CaptchaDiv').length) {
            $content.find('.LBD_CaptchaDiv').find('.LBD_ReloadLink').trigger('click');
        }
    });

    $modal.on('hide.bs.modal', function (event) {
        $alert.addClass('d-none').html('');
    });

    $form.submit(function (event) {
        event.preventDefault();

        const url = $form.attr('action');
        let data = $form.serializeArray();

        data.push({name: 'ajaxRequest', value: true});
        $.ajax({method: 'post', url: url, data: data, xhrFields: {withCredentials: true}})
            .then(function (data) {
                if (data.result) {
                    $original.removeClass('d-none');
                    $success.addClass('d-none');
                    $alert.removeClass('d-none').html(data.message);
                    if ($recaptcha.length && typeof grecaptcha !== 'undefined') {
                        if (typeof id !== 'undefined') {
                            grecaptcha.reset(id);
                        } else {
                            id = grecaptcha.render($recaptcha[0], $recaptcha.data());
                        }
                    } else if ($content.find('.LBD_CaptchaDiv').length) {
                        $content.find('.LBD_CaptchaDiv').find('.LBD_ReloadLink').trigger('click');
                    }
                } else {
                    $original.addClass('d-none');
                    $success.removeClass('d-none');
                }
            })
            .fail(function () {
                $original.removeClass('d-none');
                $success.addClass('d-none');
                $alert.removeClass('d-none').html('Unknown error');
            });
    });
});
